if (!customElements.get('cb-bouquet-path')) {
  customElements.define('cb-bouquet-path', class extends HTMLElement {
    connectedCallback() {
      this.still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.steps = [...this.querySelectorAll('.cb-bp__step')];
      this.track = this.querySelector('.cb-bp__steps');
      this.tiers = (this.dataset.tiers || '').split(',').map((t) => {
        const [m, p] = t.split(':').map((x) => parseFloat(x));
        return { m, p };
      }).filter((t) => !isNaN(t.m));
      this.max = Math.max(...this.tiers.map((t) => t.m), 1);
      this.cache = new Map();

      this.setupLive();
      this.setupShow();
      this.setupChecker();
    }

    disconnectedCallback() {
      clearInterval(this.clock);
      clearInterval(this.timer);
      if (this.io) this.io.disconnect();
    }

    la(d, o) { return d.toLocaleString('en-US', Object.assign({ timeZone: 'America/Los_Angeles' }, o)); }

    laHour() { return Number(this.la(new Date(), { hour: 'numeric', hourCycle: 'h23' })) % 24; }

    setupLive() {
      this.live = this.querySelector('[data-cb-bp-live]');
      if (!this.live) return;
      const t = window.cbTime;
      if (!t) return;
      const paint = () => {
        const d = new Date();
        const e = t.earliest();
        const h = e.hour;
        const day = this.la(d, { weekday: 'long' });
        const next = this.la(new Date(d.getTime() + 864e5), { weekday: 'long' });
        const date = t.fmt(e.date, { weekday: 'long', month: 'long', day: 'numeric' });
        const key = e.closedToday ? 'sClosed' : e.diff > 1 ? 'sLater'
          : h < t.cutoff ? 'sNight' : h < t.from ? 'sMorning' : h < t.to ? 'sDay' : 'sEvening';
        this.querySelector('[data-cb-bp-clock]').textContent = this.la(d, { hour: 'numeric', minute: '2-digit' }) + ' in LA';
        this.querySelector('[data-cb-bp-status]').textContent = (this.dataset[key] || '').replace('{day}', day).replace('{next}', next).replace('{date}', date);
        this.markNow(e.closedToday ? -1 : h);
      };
      paint();
      this.live.hidden = false;
      this.clock = setInterval(paint, 60000);
    }

    markNow(h) {
      this.steps.forEach((s) => {
        const from = parseFloat(s.dataset.from);
        const to = parseFloat(s.dataset.to);
        const on = !isNaN(from) && !isNaN(to) && h >= from && h < to;
        s.classList.toggle('is-now', on && this.shown !== false);
      });
    }

    setupShow() {
      if (!this.track || this.still || !('IntersectionObserver' in window)) return;
      this.shown = false;
      this.dataset.anim = '';
      this.steps.forEach((s) => s.classList.remove('is-lit', 'is-now'));
      this.track.style.setProperty('--cb-bp-fill', 0);
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.io.disconnect();
        this.play();
      }, { threshold: 0.35 });
      this.io.observe(this.track);
    }

    play() {
      let i = 0;
      const last = this.steps.length - 1;
      const tick = () => {
        this.steps[i].classList.add('is-lit');
        this.track.style.setProperty('--cb-bp-fill', last > 0 ? i / last : 1);
        if (i >= last) {
          clearInterval(this.timer);
          this.shown = true;
          if (this.live) this.markNow(window.cbTime && cbTime.earliest().closedToday ? -1 : this.laHour());
        }
        i += 1;
      };
      tick();
      this.timer = setInterval(tick, 750);
    }

    setupChecker() {
      this.toggle = this.querySelector('[data-cb-bp-toggle]');
      this.panel = this.querySelector('[data-cb-bp-panel]');
      if (!this.toggle || !this.panel) return;
      this.form = this.querySelector('[data-cb-bp-form]');
      this.input = this.querySelector('[data-cb-bp-input]');
      this.dest = this.querySelector('[data-cb-bp-dest]');
      this.bands = [...this.querySelectorAll('.cb-bp__band')];
      this.ladder = [...this.querySelectorAll('.cb-bp__tier')];

      this.toggle.setAttribute('role', 'button');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const open = this.panel.hidden;
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
        if (open) {
          this.panel.classList.remove('is-opening');
          // Touch: the keyboard covers the field, so put the panel under the sticky header first
          if (matchMedia('(pointer: coarse)').matches) {
            const head = [...document.querySelectorAll('.shopify-section-group-header-group')].reduce((b, n) =>
              (/sticky|fixed/.test(getComputedStyle(n).position) ? Math.max(b, n.getBoundingClientRect().bottom) : b), 0);
            window.scrollTo(0, this.panel.getBoundingClientRect().top + window.scrollY - head - 12);
          }
          void this.panel.offsetWidth;
          this.panel.classList.add('is-opening');
          this.input.focus({ preventScroll: true });
        }
      });
      this.toggle.addEventListener('keydown', (e) => {
        if (e.key === ' ') { e.preventDefault(); this.toggle.click(); }
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.check(this.input.value.trim());
      });
    }

    show(state, where) {
      this.querySelectorAll('[data-cb-bp-state]').forEach((el) => { el.hidden = el.dataset.cbBpState !== state; });
      this.querySelectorAll('[data-cb-bp-where]').forEach((el) => { el.textContent = where || ''; });
    }

    mark(tier) {
      this.bands.forEach((b) => b.classList.toggle('is-on', +b.dataset.band === tier));
      this.ladder.forEach((l) => l.classList.toggle('is-on', +l.dataset.tier === tier));
      if (tier < 0 || !this.tiers[tier]) {
        this.dest.style.opacity = 0;
        this.dest.style.transform = '';
        return;
      }
      const inner = tier > 0 ? this.tiers[tier - 1].m : 0;
      const r = (inner + this.tiers[tier].m) / 2 / this.max * 50;
      const a = -35 * Math.PI / 180;
      const size = this.dest.parentElement.offsetWidth / 100;
      this.dest.style.opacity = 1;
      this.dest.style.transform = `translate(${Math.cos(a) * r * size}px, ${Math.sin(a) * r * size}px)`;
    }

    // Delivery price: window.cbQuote (snippets/cb-time-js.liquid)
    quote(value) { return window.cbQuote(this.dataset.variant, value); }

    async check(value) {
      if (!value) { this.input.focus(); return; }
      const zipOnly = /^\d{5}$/.test(value);
      const key = value.toLowerCase();
      const where = zipOnly ? 'ZIP ' + value : value;
      const n = (this.req = (this.req || 0) + 1);
      this.show('loading', where);
      this.mark(-1);
      let price;
      try {
        price = this.cache.has(key) ? this.cache.get(key) : await this.quote(value, zipOnly);
        this.cache.set(key, price);
      } catch (err) {
        if (n === this.req) this.show('error');
        return;
      }
      if (n !== this.req) return;
      if (price === null) { this.show('none', where); return; }

      const tier = this.tiers.findIndex((t) => Math.abs(t.p - price) < 0.01);
      const free = this.querySelector('.cb-bp__tier b');
      const freeLabel = free && price === 0 ? free.textContent : '';
      this.querySelector('[data-cb-bp-price]').textContent = price === 0 ? freeLabel + ' delivery' : '$' + (price % 1 ? price.toFixed(2) : price) + ' delivery';
      const range = tier > -1 ? this.ladder[tier].dataset.range : '';
      this.querySelector('[data-cb-bp-range]').textContent = range ? range.charAt(0).toUpperCase() + range.slice(1) + ' from our shop.' : '';
      this.querySelector('[data-cb-bp-zipnote]').hidden = !zipOnly;
      this.show('ok', where);
      this.mark(tier);
    }
  });
}
